import { makeStyles, Theme } from '@material-ui/core/styles';
import { color } from 'html2canvas/dist/types/css/types/color';

export const useStyles = makeStyles((theme: Theme) => ({
  quillWrapper: {
    color: '#151528',
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    '& .ql-container': {
      fontSize: '14px !important',
      height: '100% !important',
    },
    '& .ql-toolbar.ql-snow': {
      borderTopRightRadius: '4px !important',
      borderTopLeftRadius: '4px !important',
    },
    '& .ql-container.ql-snow': {
      borderBottomRightRadius: '4px !important',
      borderBottomLeftRadius: '4px !important',
    },
    '& .ql-editor.ql-blank::before': {
      color: '#9799B1 !important',
      fontFamily: 'Poppins !important',
      fontWeight: '500 !important',
      fontSize: '14px !important',
      lineHeight: '20px !important',
      letterSpacing: '0% !important',
      fontStyle: 'normal !important',
    },
  },
  container: {
    backgroundColor: '#f5f5f5',
    padding: 0,
    margin: 0,
    overflow: 'hidden',
  },
  header: {
    padding: '16px 16px 0 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButton: {
    backgroundColor: 'white',
    color: '#23296F',
    borderRadius: '4px',
    border: '1.5px solid #CDCEDA',
    padding: theme.spacing(1, 2),
    fontSize: '0.9rem',
    textTransform: 'none',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5, 1),
      fontSize: '0.8rem',
    },
    '&:hover': {
      backgroundColor: '#000A8C',
      color: 'white',
      '& svg': {
        filter: 'brightness(0) saturate(100%) invert(1)',
      },
    },
    '& svg': {
      transition: 'filter 0.3s',
    },
    '& .MuiButton-startIcon': {
      margin: 0,
      marginRight: '10px',
      marginBottom: '6px',
    },
  },
  mainContent: {
    padding: theme.spacing(2),
  },
  chatArea: {
    height: 'calc(100vh - 180px)',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  chatMessages: {
    flex: 1,
    backgroundColor: '#ffffff',
    color: '#FFFFFF',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    overflowY: 'auto',
    minHeight: '60%',
    maxHeight: '75vh',
  },
  chatInput: {
    height: '80px',
  },
  messageUserHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'end',
    gap: theme.spacing(0),
    marginBottom: '10px',
  },
  messageBotHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'start',
    gap: theme.spacing(0),
    marginBottom: '10px',
  },
  messageUserContainer: {
    padding: theme.spacing(2),
    borderRadius: 12,
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    width: 'fit-content',
    maxWidth: '75%',
  },
  messageUserContent: {
    backgroundColor: '#5763FF',
    padding: theme.spacing(2),
    borderRadius: 12,
    textAlign: 'left',
    color: '#FFFFFF',
    '& p': {
      margin: 0,
    },
  },
  messageBotContainer: {
    color: '#151528',
    padding: theme.spacing(2),
    borderRadius: 12,
    marginBottom: theme.spacing(2),
    marginRight: '25%',
  },
  messageBotContent: {
    overflowX: 'scroll',
    backgroundColor: '#EDEEF2',
    padding: theme.spacing(2),
    borderRadius: 12,
    lineHeight: '22px',
    '& p': {
      margin: 0,
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      lineHeight: '1.5',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    '& h1': {
      fontSize: '23px',
    },
    '& h2': {
      fontSize: '21px',
    },
    '& h3': {
      fontSize: '19px',
    },
    '& h4': {
      fontSize: '17px',
    },
  },
  synthesisArea: {
    height: 'calc(100vh - 180px)',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  synthesisHeader: {
    backgroundColor: '#ffffff',
    borderRadius: '5px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  synthesisHeaderTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '-webkit-fill-available',
  },
  synthesisHeaderBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '-webkit-fill-available',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
  synthesisTitle: {
    color: '#5763FF',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0%',
    width: '-webkit-fill-available',
  },
  synthesisStatus: {
    color: '#9799B1',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    textAlign: 'right',
    width: '-webkit-fill-available',
  },
  synthesisEditor: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
  },
  synthesisActions: {
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 8,
    paddingTop: 8,
    backgroundColor: '#FFFFFF',
    zIndex: 2,
  },
  editorToolbar: {
    backgroundColor: '#9e9e9e',
    padding: theme.spacing(1),
    borderRadius: '8px 8px 0 0',
    display: 'flex',
    gap: theme.spacing(1),
  },
  toolbarButton: {
    minWidth: 32,
    height: 32,
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.2)',
    },
  },
  editorContent: {
    flex: 1,
    border: '1px solid #ddd',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    padding: theme.spacing(2),
    minHeight: 120,
    resize: 'none',
    fontFamily: 'inherit',
    fontSize: '14px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  synthesizeButton: {
    width: '100%',
    backgroundColor: '#000A8C',
    color: '#FFFFFF',
    borderRadius: '4px',
    height: '48px',
    padding: theme.spacing(1.5, 3),
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '160%',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#000A8C',
    },
    '&:disabled': {
      backgroundColor: '#9799B1',
      color: '#FFFFFF',
      border: 'none',
    },
    [theme.breakpoints.down('lg')]: {
      padding: 0,
    },
    '@media (max-height: 820px)': {
      height: '44px',
      fontSize: '13px',
    },
  },
  synthesizeOutlinedButton: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    color: '#000A8C',
    borderRadius: '4px',
    height: '48px',
    border: '1px solid #000A8C',
    padding: theme.spacing(1.5, 3),
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '160%',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#000A8C',
      color: 'white',
    },
    '&:disabled': {
      backgroundColor: '#9799B1',
      color: '#FFFFFF',
      border: 'none',
    },
    [theme.breakpoints.down('lg')]: {
      padding: 0,
    },
    '@media (max-height: 820px)': {
      height: '44px',
      fontSize: '13px',
    },
  },
  userLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: '#0E1247',
  },
  exploreButtonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  exploreButton: {
    backgroundColor: '#5763FF',
    color: '#FFFFFF',
    borderRadius: 16,
    padding: theme.spacing(1, 2),
    marginLeft: '5px',
    fontSize: '0.85rem',
    textTransform: 'none',
    marginTop: theme.spacing(1),
    height: '45px',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#000A8C',
    },
    '&:disabled': {
      backgroundColor: '#9799B1',
      color: '#FFFFFF',
      cursor: 'not-allowed',
    },
  },
  inputPlaceholder: {
    '&::placeholder': {
      color: '#9799B1',
      opacity: 1,
    },
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: '32px',
  },
  formField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  formLabel: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    color: '#1f2937',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  optionalLabel: {
    fontWeight: 400,
    color: '#9CA3AF',
    fontSize: '12px',
  },
  formInput: {
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'Poppins',
    color: '#374151',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
      borderColor: '#3B82F6',
      boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
    },
    '&::placeholder': {
      color: '#9CA3AF',
    },
  },
  contextTextarea: {
    width: '100%',
    minHeight: '120px',
    padding: '16px',
    borderRadius: '4px',
    border: '1px solid #CDCEDA',
    fontFamily: 'Poppins',
    fontSize: '14px',
    lineHeight: '160%',
    color: '#0E1247',
    backgroundColor: '#FFFFFF',
    resize: 'vertical',
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: '#5763FF',
      boxShadow: '0 0 0 2px rgba(87, 99, 255, 0.1)',
    },
    '&::placeholder': {
      color: '#9CA3AF',
      fontStyle: 'italic',
    },
  },
  placeholder: {
    color: '#9CA3AF',
    fontStyle: 'italic',
  },
  bottomContainer: {
    paddingTop: '20px',
    paddingBottom: '60px',
    flexShrink: 0,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
  },
  baseButton: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '160%',
    letterSpacing: '0%',
    textTransform: 'none',
    textAlign: 'center',
    padding: '12px 24px',
    borderRadius: '3px',
    height: '43px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'none',
  },
  primaryButton: {
    backgroundColor: '#000A8C',
    width: '100%',
    color: '#FFFFFF',
    '&:hover:not(:disabled)': {
      backgroundColor: '#1a1f5a',
    },
    '&:disabled': {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    overflow: 'hidden',
    margin: theme.spacing(1, 0),
    fontFamily: 'Poppins',
    fontSize: '14px',
  },
  tableHeader: {
    border: '1px solid black',
    padding: theme.spacing(1.5, 2),
    textAlign: 'left',
    fontWeight: 600,
    color: '#374151',
    fontSize: '14px',
    fontFamily: 'Poppins',
  },
  tableCell: {
    border: '1px solid black',
    padding: theme.spacing(1.5, 2),
    color: '#374151',
    fontSize: '14px',
    fontFamily: 'Poppins',
  },
  noBorder: {
    border: 'none !important',
    '&:hover': {
      border: 'none !important',
    },
    '&.Mui-focused': {
      border: 'none !important',
    },
  },
  multilineInput: {
    '& .MuiInputBase-input': {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      resize: 'none',
    },
  },
}));
